import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import Teams from '../../api/team';
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import ContactSectionS4 from '../../components/ContactSectionS4/ContactSectionS4';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.jpeg'

const TeamSinglePage = () => {
    const { slug } = useParams()
    const teamSingle = Teams.find(item => item.slug === slug)

    if (!teamSingle) {
        return <h2 style={{ textAlign: 'center', marginTop: '100px' }}>Team Member Not Found</h2>
    }

    return (
        <Fragment>
            <NavbarS4
                hclass={'wpo-site-header wpo-header-style-s11'}
                Logo={Logo}
                col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'}
            />

            <PageTitle pageTitle={teamSingle.title} pagesub={'Team Details'} />
            <ScrollTextAnimation />

            <section className="wpo-teame-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-7 col-12">
                            <div className="left-sidbar">
                                <div className="image">
                                    <img src={teamSingle.Sime} alt={teamSingle.title} />
                                </div>

                                <div className="info-description">
                                    <h2 className="fade_bottom">Professional Info</h2>

                                    {teamSingle.professionalInfo.map((para, index) => (
                                        <p key={index}>{para}</p>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5 col-12">
                            <div className="right-sidbar">
                                <div className="personal-info">
                                    <h3>Personal Info</h3>
                                    <ul>
                                        <li><span>Position:</span> <span>{teamSingle.position}</span></li>
                                        <li><span>Practice Area:</span> <span>{teamSingle.practiceArea}</span></li>
                                        <li><span>Experience:</span> <span>{teamSingle.experience}</span></li>
                                        <li><span>Address:</span> <span>{teamSingle.address}</span></li>
                                        <li><span>Phone:</span> <span>{teamSingle.phone}</span></li>
                                        <li><span>Email:</span> <span>{teamSingle.email}</span></li>
                                    </ul>
                                </div>

                                <div className="skill_wrap">
                                    <div className="skill">
                                        <h3>Professional Skills</h3>

                                        {teamSingle.skills.map((skill, index) => (
                                            <div className="progress_item" key={index}>
                                                <span>{skill.name}</span>
                                                <div className="progres">
                                                    <div className="progress-value" style={{ width: skill.value }}>
                                                        <span>{skill.value}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ContactSectionS4 />
            <PartnerSection hclass={'wpo-partners-section fade_bottom'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default TeamSinglePage;
